"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dispatchEvent = void 0;
const dispatchEvent = (eventName, value) => {
  const customEvent = new CustomEvent(eventName, {
    bubbles: true,
    detail: {
      value
    }
  });
  window.dispatchEvent(customEvent);
};
exports.dispatchEvent = dispatchEvent;